import type { Project } from '@/entities/project';
import request from '@/shared/api/request';

export const createProject = (data: {
  name: string;
  description: string;
  color: string;
}): Promise<{ project: Project }> =>
  request({
    url: '/projects/',
    method: 'POST',
    data,
  });
